import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'
import { getOrganizations } from 'src/redux/slices/user/endpoints'
import { selectActiveOrganization } from 'src/redux/slices/user/selectors'

import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt'

import LibraryManager from '../components/LibraryManager'
import ProjectCreator from '../components/ProjectCreator'
import ProjectManager from '../components/ProjectManager'
import ProjectsList from '../components/ProjectsList'
import TeamSelector from '../components/TeamSelector'

const useStyles = makeStyles(() => ({
  divider: {
    marginTop: '1rem',
    marginBottom: '1rem',
  },
  button: {
    marginTop: '1rem',
  },
}))

///// Component
const ProjectsPage: React.FC = () => {
  const { data, isLoading } = getOrganizations.useQuery('')
  const activeTeam = useSelector(selectActiveOrganization)
  const classes = useStyles()
  const { goToTab } = useTabNavigation()
  const goToTeams = useCallback(() => {
    goToTab('teams')
  }, [goToTab])

  if (isLoading) return <CircularProgress />

  if ((data?.length ?? 0) === 0)
    return (
      <div>
        <Typography variant='body2'>
          You must create or join a team before creating a project.
        </Typography>
        <Button
          size='small'
          onClick={goToTeams}
          variant='contained'
          color='primary'
          className={classes.button}
          endIcon={<ArrowRightAltIcon />}
        >
          Your Teams
        </Button>
      </div>
    )
  return (
    <div>
      <TeamSelector />
      <Divider className={classes.divider} />
      <ProjectManager />
      <Divider className={classes.divider} />
      {!!activeTeam && <LibraryManager />}
    </div>
  )
}

export default ProjectsPage
